import React from 'react';
import { useLocation } from 'react-router-dom';

export const useMintLayout = () => {
  const { pathname } = useLocation();
  return (
    pathname === '/create' ||
    pathname.startsWith('/create/') ||
    pathname === '/profile' ||
    pathname.startsWith('/profile/')
  );
};

/** Launch chrome matches final Cryptoverse-AI-Frontend prototype. */
const LIVE_LABEL = 'ETHEREUM';
const SOON_LABEL = 'ARBITRUM · MONAD · SOLANA · ZKSYNC';

const CvTopRail = () => {
  const mintLayout = useMintLayout();

  return (
    <div className="rail">
      <div className={mintLayout ? 'wrap--mint' : 'wrap'}>
        <span className="g">●</span>
        <b>NOW LIVE</b>
        <span>{LIVE_LABEL}</span>
        <span style={{ marginLeft: 'auto' }}>{SOON_LABEL} SOON</span>
      </div>
    </div>
  );
};

export default CvTopRail;
